if (!customElements.get("td-product-form")) {
  class TdProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
    
    }

    connectedCallback() {
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.form.addEventListener('change', this.updateATC.bind(this))
        this.updateATC()
      }
    }

    updateATC() {
      const priceElement = this.querySelector('.product-price-display');
      const selectedVariant = this.querySelector('[name="id"]:checked');
      const selectedPlan = this.querySelector('[name="selling_plan_select"]:checked');

      if (selectedVariant?.dataset?.price && priceElement) {
        const price = selectedPlan && selectedPlan.value === 'subsave' 
          ? selectedPlan.dataset.price 
          : selectedVariant.dataset.price;

        priceElement.innerHTML = price;

        const compareAtPrice = selectedPlan && selectedPlan.value === 'subsave' 
          ? selectedPlan.dataset.compareAtPrice 
          : selectedVariant.dataset.compareAtPrice;

        if (compareAtPrice) {
          let compareAtPriceElement = priceElement.querySelector('.compare-at-price');
          if (!compareAtPriceElement) {
            compareAtPriceElement = document.createElement('span');
            compareAtPriceElement.classList.add('compare-at-price');
            priceElement.prepend(compareAtPriceElement);
          }
          compareAtPriceElement.innerHTML = compareAtPrice;
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const variantId = this.querySelector('[name="id"]:checked');
      const sellingPlan = this.querySelector('.active [name="selling_plan"]') ? this.querySelector('.active [name="selling_plan"]').value : false;

      if (!variantId) return;
      const data = {
        items: [
          {
            id: variantId.value,
            quantity: 1,
            ...(sellingPlan && { selling_plan: sellingPlan })
          }
        ]
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then(() => {
          this.updateCartDisplay(true);
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
        });
    }

    updateCartDisplay(openCart = false) {
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(() => {
          if (GND) {
            GND.sidecart.refresh();
          }
          if (openCart && RC) {
            RC.sidePanel.open("#cart_panel");
          }
        })
        .catch((error) => {
          console.error("Error updating cart display:", error);
        });
    }
  }

  customElements.define("td-product-form", TdProductForm);
}